const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
const { __ } = wp.i18n;
const ServerSideRender = wp.serverSideRender;

registerBlockType('pg/breadcrumbs', {
  title: __('PG Breadcrumbs'),
  icon: 'admin-links',
  category: 'layout',
  attributes: {
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { sectionClass } = attributes;

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    // Add the JavaScript logic to fetch and display breadcrumbs
    const fetchBreadcrumbs = () => {
      if (wp.data && wp.data.select('core/editor')) {
        const post = wp.data.select('core/editor').getCurrentPost();
        const breadcrumbsContainer =
          document.querySelector('.intro-breadcrumbs');

        if (post && breadcrumbsContainer) {
          const breadcrumbs = [];
          breadcrumbsContainer.innerHTML = '';
          breadcrumbs.push('<span><a href="/">Start</a></span>');

          const getParentBreadcrumbs = (parentId, callback) => {
            wp.apiFetch({ path: `/wp/v2/pages/${parentId}` }).then((parent) => {
              if (parent.parent) {
                getParentBreadcrumbs(parent.parent, (parentBreadcrumbs) => {
                  parentBreadcrumbs.push(
                    `<span><a href="${parent.link}">${parent.title?.rendered ? parent.title.rendered : parent.title}</a></span>`
                  );
                  callback(parentBreadcrumbs);
                });
              } else {
                const parentBreadcrumbs = [
                  `<span><a href="${parent.link}">${parent.title?.rendered ? parent.title.rendered : parent.title}</a></span>`,
                ];
                callback(parentBreadcrumbs);
              }
            });
          };

          if (post.parent) {
            getParentBreadcrumbs(post.parent, (parentBreadcrumbs) => {
              breadcrumbs.push(...parentBreadcrumbs);
              breadcrumbs.push(
                `<span class="breadcrumb_last">${post.title?.rendered ? post.title.rendered : post.title}</span>`
              );
              breadcrumbsContainer.innerHTML = `<span>${breadcrumbs.join(' » ')}</span>`;
            });
          } else {
            breadcrumbs.push(
              `<span class="breadcrumb_last">${post.title?.rendered ? post.title.rendered : post.title}</span>`
            );
            breadcrumbsContainer.innerHTML = `<span>${breadcrumbs.join(' » ')}</span>`;
          }
        }
      }
    };

    // Ensure the function runs when the block is loaded
    wp.domReady(() => {
      fetchBreadcrumbs();
    });

    return (
      <>
        <InspectorControls>
          <PanelBody title={__('Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
          </PanelBody>
        </InspectorControls>
        <div className={sectionClass}>
          <div className={'inner'}>
            <div className="breadcrumbs intro-breadcrumbs"></div>
          </div>
        </div>
      </>
    );
  },
  save: () => {
    return null; // Rendered server-side.
  },
});
